module.exports = "<p>mirin-verify works!</p>\n"